import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

const DashboardLayout = ({
  notifications,
  leftColumn,
  rightColumn,
  unreadMessageNotification,
  charityPopup,
}) => {

  const clientSettings = useSelector(state => state.common.clientSettings);

  return  (
    <div className="apl-dashboard grid__wrapper">
      <div className="grid__item grid__item--full">{unreadMessageNotification}</div>
      {charityPopup ? charityPopup : null}
      <div className={clientSettings.newUIFlag ? "grid__item grid__item--three" :"grid__item grid__item--eight" }>
        {notifications}
        {leftColumn}
      </div>
      <div className={clientSettings.newUIFlag ? "grid__item grid__item--nine" : "grid__item grid__item--four"}>{rightColumn}</div>
    </div>
  );
}

DashboardLayout.propTypes = {
  notifications: PropTypes.element,
  leftColumn: PropTypes.element,
  rightColumn: PropTypes.element,
  unreadMessageNotification: PropTypes.element,
  charityPopup: PropTypes.element,
};

export default DashboardLayout;



// WEBPACK FOOTER //
// ./components/dashboard/Layout.js